/* 🤖 this file was generated by svg-to-ts */
export const matIconRtt: {
  name: 'rtt';
  data: string;
} = {
  name: 'rtt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m9.03 3-1.11 7.07h2.62l.7-4.5h2.58L11.8 18.43H9.47L9.06 21h7.27l.4-2.57h-2.35l2-12.86h2.58l-.71 4.5h2.65L22 3H9.03zM8 5H4l-.31 2h4L8 5zm-.61 4h-4l-.31 2h4l.31-2zm.92 8h-6L2 19h6l.31-2zm.62-4h-6l-.31 2h6.01l.3-2z"/></svg>`
};
